/**
 * Wrapper for the already registered window.webAnalytics function, with type hinting
 *
 * @param  {number} eventID  The ID of the event to be inserted.
 * @param  {String} value  The event value to be inserted.
 * @param  {Boolean} isAsync Whether the call is made asynchronously. Defaults to true
 */
export function sendWAEvent(eventId, value, isAsync) {
  window.webAnalytics.sendWAEvent(eventId, value, isAsync);
}